export var FORGOT_PASSWORD_PATTERN='/forgot-password';